// SPDX-License-Identifier: MIT
import { SelectionEntry } from '../types';

export class SelectionManager {
  private max: number;
  private map = new Map<string, SelectionEntry>();
  constructor(max = 10) {
    this.max = max;
  }
  add(entry: SelectionEntry): { added: boolean; overLimit: boolean } {
    if (this.map.has(entry.path)) return { added: false, overLimit: false };
    if (this.map.size >= this.max) return { added: false, overLimit: true };
    this.map.set(entry.path, entry);
    return { added: true, overLimit: false };
  }
  remove(path: string) {
    this.map.delete(path);
  }
  toggle(entry: SelectionEntry): { added: boolean; overLimit: boolean } {
    if (this.map.has(entry.path)) {
      this.map.delete(entry.path);
      return { added: false, overLimit: false };
    }
    if (this.map.size >= this.max) {
      return { added: false, overLimit: true };
    }
    this.map.set(entry.path, entry);
    return { added: true, overLimit: false };
  }
  clear() {
    this.map.clear();
  }
  list(): SelectionEntry[] {
    return Array.from(this.map.values());
  }
  count(): number {
    return this.map.size;
  }
}
